import { Box } from '@dixa/lib-shared-habla';

import { AiLoadingState } from 'components/aiLoadingState';

type Props = {
  loadingText: string;
};

export const UIBlockerLoading = ({ loadingText }: Props): JSX.Element => (
  <Box style={{ position: 'absolute', bottom: 16 }}>
    <AiLoadingState label={loadingText} />
  </Box>
);
